async function sendMessage(input = '', options = {}) {
    if (!input) throw Error('No Input provided')
    if (!options.MessageService) throw Error('No MessageService provided')

    const { MessageService = {}, messageAttributes = {} } = options
    const { send } = MessageService
    
    if (!send) throw Error('No send function provided in MessageService')
    
    let response = {}
    try {
        const interactionResponse = await send(input)
        if (!!interactionResponse.message) {
            response = formatInteractionResponse(interactionResponse)
        } else {
            throw Error('No response given')
        }
    } catch (error) {
        response.content = 'Something went wrong! Would you like to try again?'
        response.hideFeedback = true
        response.suggestions = [
            {
                "title": "Suggestions",
                "buttons": [
                    {
                        "text": 'Try again',
                        "value": input
                    },
                    {
                        "text": "Help",
                        "value": "Help"
                    }
                ]
            }
        ]

    }
    
    return {
        ...messageAttributes,
        ...response
    }
}

function formatInteractionResponse(response) {
    const { message, responseCard = {}, sessionAttributes } = response

    let formattedResponse = {
        content: message
    }

    if (!!sessionAttributes.appContext) {
        let appContext = JSON.parse(sessionAttributes.appContext)
        if (!!appContext.altMessages && !!appContext.altMessages.markdown) {
            formattedResponse.content = appContext.altMessages.markdown
        }
    }

    if (Array.isArray(responseCard.genericAttachments) && responseCard.genericAttachments.length > 0) {
        const { genericAttachments } = responseCard

        formattedResponse.suggestions = genericAttachments
            .map(attachment => ({
                title: attachment.title,
                subTitle: attachment.subTitle,
                imageUrl: attachment.imageUrl,
                buttons: Array.isArray(attachment.buttons) ? attachment.buttons : []
            }))
            .filter(attachment => attachment.buttons.length > 0)
    }

    return formattedResponse
}

const MessageController = (options = {}) => ({
    sendMessage: (input = '', messageOptions = {}) => sendMessage(input, {
        MessageService: options.MessageService,
        ...messageOptions
    })
})

export default MessageController